import api from "../api";

export function viewModuleRequest(id) {
  return api.get(`/module_documents/${id}`);
}
